export enum ButtonState {
  PRIMARY_ENABLED = 'primary',
  PRIMARY_DISABLED = 'primary disabled',
}
